import type { Responsive } from '@store'

export const RESPONSIVE_SIZE: { [Key in Responsive]: number | null } = {
  mobile: 768,
  tablet: 1024,
  desktop: null,
}
